import StandardDocPage from "./components/standard-doc-page/standard-doc.page";
import ErpDocPage from "./components/erp-doc-page/erp-doc.page";

const DocPage = (props: any) => {

    const markup = props.doc_page_type == 'erp' ? (<ErpDocPage {...props}/>) : <StandardDocPage {...props}/>
    return (markup)
}

export default DocPage